module.exports = __webpack_public_path__ + "media/13.c3691a36.mp3";